import http, { ResponseData } from './httpService'
import { IsaacMerchantSignupReqVO } from '../typings/merchant'

export const signupMerchant = async (vo: IsaacMerchantSignupReqVO): Promise<void> => {
  await http.post<ResponseData<String>>('/fe/user/center/merchant/signup', vo)
}
